<div class="content">
  <ng-container *ngComponentOutlet="this.contentList[this.selected.id]" />
</div>
